export const COOKIE_CUSTOMER_IDENTIFIER = "CUSTOMER_IDENTIFIER";
export const COOKIE_SHOP_TOKEN = "SHOP_TOKEN";
export const COOKIE_CART_ID = "CART_ID";
export const COOKIE_PRODUCT_GROUP = "PRODUCT_GROUP"
export const FILTER_OPTIONS = "filter_options"


export const PRODUCTS_PER_PAGE_FALLBACK = 32